export default "__VITE_ASSET__CDVFzKyA__"